import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';

const AddEtatMajorSuccessifs = () => {
  const initialValues = {
    nomprenom: '',
    du: '',
    au: '',
    file: null,
  };

  const validationSchema = Yup.object({
    nomprenom: Yup.string().required('Nom et prénom sont requis'),
    du: Yup.date().required('Date de début est requise'),
    au: Yup.date().required('Date de fin est requise'),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const formData = new FormData();
    formData.append('nomprenom', values.nomprenom);
    formData.append('du', values.du);
    formData.append('au', values.au);
    if (values.file) {
      formData.append('file', values.file);
    }

    try {
      await axios.post('/etatmajorsuccessifs/add', formData).then((res) => console.log(res.data));
      alert('Etat Major Successif ajouté avec succès');
    } catch (error) {
      console.error(error);
      alert("Erreur lors de l'ajout");
    }
    setSubmitting(false);
  };

  return (
    <div className="container mt-5 pt-4">
      <h1>Ajouter un Etat Major Successif</h1>
      <Formik encType="multipart/form-data" initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {({ isSubmitting, setFieldValue }) => (
          <Form>
            <div>
              <label>Nom et Prénom</label>
              <Field className="form-control" name="nomprenom" />
            </div>
            <div>
              <label>Du</label>
              <Field className="form-control" name="du" type="date" />
            </div>
            <div>
              <label>Au</label>
              <Field className="form-control" name="au" type="date" />
            </div>
            <div>
              <label>Fichier</label>
              <input
                name="file"
                type="file"
                onChange={(event) => {
                  setFieldValue('file', event.currentTarget.files[0]);
                }}
                className="form-control"
              />
            </div>
            <button className="btn btn-primary pt-3 " type="submit" disabled={isSubmitting}>
              Ajouter
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddEtatMajorSuccessifs;
